export default "__VITE_ASSET__9cfe8b47__"